import { QuestionBase } from "./question-base.model";

export class PushableQuestion extends QuestionBase<string> {
   controlType = 'pushable';
   id: string;
   options: { key: string, value: string }[] = [];
   disabled: boolean;
   value: any;
   visible: boolean;
   bannerJson: any;
   pushable_master: any = {};

   constructor(options: {} = {}) {
      super(options);
      this.options = options['options'] || [];
      this.id = options['id'];
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      this.value = options['default'] || '';
      this.conditions = options['conditions'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.bannerJson = options['bannerJson'];
      this.pushable_master = options['pushable_master']
   }
}
